'use strict'
import Vue from 'vue'
import VueWorker from 'vue-worker'

import './plugins/auth'
import './plugins/axios'
import './plugins/crypto'
import './plugins/datepicker'
import './plugins/moment'
import './plugins/visibility'
import './plugins/sweetalert'
import './plugins/hotkeys'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.use(VueWorker)

require('./helpers/filters')
require('./config')

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
